<script setup lang="ts">
import { inject } from 'vue'
import dataLayer from '@/components/dataLayerHelper'

const isReauthMode = inject<boolean>('reauthMode', false)

const subtext1 = isReauthMode ? 'reauthForm.subtext1' : 'form.subtext1'
const showSubText2 = !isReauthMode
</script>

<template>
  <p data-testid="form-intro-para" class="lead mb-4 text-balance">
    {{ $t(subtext1) }}
  </p>
  <i18n-t
    v-if="showSubText2"
    keypath="form.subtext2"
    scope="global"
    tag="p"
    class="lead text-balance"
    data-testid="form-intro-para2"
  >
    <a
      :href="$t('form.subtextLinkHref')"
      @click="dataLayer.sendLearnSaClick"
      target="_blank"
      class="fw-semibold"
    >
      {{ $t('form.subtextLinkText') }}
    </a>
  </i18n-t>
</template>
